<template>
  <div>
    <div class="black-overlay"></div>
    <div class="modal modal--welcomeback" id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header modal_ti_header">

        </div>
        <div class="modal__body">
          <h1>{{ getTranslations.home_modals_resubscribe_request_do_you_want }}</h1>
          <!--h2>$#Your points: <span class="points">XXX</span></h2>
          <h2>$#Your level: <span class="level">Y</span></h2-->
          <img class="modal_icon_alert" :src="getTranslations.project_config_modal_img" />
          <p>{{ getTranslations.home_modals_resubscribe_request_by_resubscribing }} </p>


          <a class="ti_btn--main" @click.prevent="reOptin" style="cursor:pointer">
              {{ getTranslations.home_modals_resubscribe_request_resubscribe }}
          </a>
          <span class="terms">
          {{ getTranslations.home_modals_resubscribe_request_by_clicking }}<br>
         <span class="make_it_bold"> <a style="cursor:pointer" :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank">{{ getTranslations.home_modals_resubscribe_request_t_and_cs
           }}</a> </span>{{ getTranslations.home_modals_resubscribe_request_of_the_service }}
        </span>
      </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import modals from '../../../common/modals';
import WelcomeReturningUnsub from './WelcomeReturningUnsub';
import ResubscribeViaPin from './ResubscribeViaPin';
import ResubscribeError from './ConfirmPurchaseForPinError';

export default {
  // modal_resubscribe-request.html
  name: 'resubscribe-request-settings',
  mixins: [IntegrationMixin],
  methods: {
    ...mapActions('common', [
      'reOptinProcess',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForSettings',
    ]),
    reSubCallback(response) {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        this.getUserLoginDetails().then(() => {
          if (this.reoptinOnestep) {
            if (this.userDetails.subscribed) {
              this.storeModalForSettings(WelcomeReturningUnsub);
              modals.showHideModalForHomePage(this);
            } else {
              this.storeModalForSettings(ResubscribeError);
              modals.showHideModalForHomePage(this);
            }
          } else {
            // eslint-disable-next-line
            if (!this.userDetails.subscribed) {
              this.storeModalForSettings(ResubscribeViaPin);
              modals.showHideModalForHomePage(this);
            } else {
              this.storeModalForSettings(ResubscribeError);
              modals.showHideModalForHomePage(this);
            }
          }
        });
      } else {
        this.storeModalForSettings(ResubscribeError);
        modals.showHideModalForHomePage(this);
      }
    },
    reOptin() {
      // eslint-disable-next-line
      console.log('Resubscribe user Call');
      this.getAppropriateReSubAction();
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'reoptinOnestep',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeRequestSettings.vue